import * as React from "react";
import { Tooltip } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { Edit, Play, Star, StarOff, Trash } from "lucide-react";
import { PromptLibraryItem } from "@/modules/promptLibrary/promptLibrary.types";

interface Props {
  item: PromptLibraryItem;
  userId: string;
  handleTrashClick: (item: PromptLibraryItem) => void;
  handleApplyClick: (item: PromptLibraryItem) => void;
  handleFavoriteClick: (item: PromptLibraryItem) => void;
  handleEditClick: (item: PromptLibraryItem) => void;
}

export const PromptLibraryTableActions: React.FC<Props> = ({
  item,
  userId,
  handleTrashClick,
  handleEditClick,
  handleFavoriteClick,
  handleApplyClick,
}) => (
  <div className="flex gap-1">
    <Tooltip text="Delete prompt">
      <Button
        variant="secondary"
        size="sm"
        disabled={item.user_id !== userId}
        className="w-full text-xs sm:w-auto"
        onClick={() => handleTrashClick(item)}
      >
        <Trash className="mr-1 h-3 w-3" />
      </Button>
    </Tooltip>

    <Tooltip text={item.is_favorite ? "Remove from favorites" : "Add to favorites"}>
      <Button
        variant="secondary"
        size="sm"
        disabled={item.user_id !== userId}
        className={"w-full text-xs sm:w-auto"}
        onClick={() => handleFavoriteClick(item)}
      >
        {item.is_favorite ? <StarOff className="mr-1 h-3 w-3" /> : <Star className="mr-1 h-3 w-3" />}
      </Button>
    </Tooltip>

    <Tooltip text="Edit">
      <Button
        variant="secondary"
        size="sm"
        disabled={item.user_id !== userId}
        className="w-full fill-amber-400 text-xs sm:w-auto"
        onClick={() => handleEditClick(item)}
      >
        <Edit className="mr-1 h-3 w-3" />
      </Button>
    </Tooltip>

    <Tooltip text={`Apply prompt to: ${item.source.toUpperCase()}`}>
      <Button variant="secondary" size="sm" className="w-full text-xs sm:w-auto" onClick={() => handleApplyClick(item)}>
        <Play className="mr-1 h-3 w-3" />
      </Button>
    </Tooltip>
  </div>
);
